import { tvMountQA, tvDismountQA } from './skuConstants';

export const RICH_FAQ_SKUS = {
  'tv-wall-mounting-install': tvMountQA,
  'tv-dismount-remount': tvDismountQA,
};
